export function _get(param, callback) {
  const request = new XMLHttpRequest();

  request.open('GET', param);
  request.onreadystatechange = callback;
  request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  request.send();

  return request;
}

export function get(param, callback) {
  return _get(param, callback);
}

export function _post(param, callback, extraHeaders, data) {
  const request = new XMLHttpRequest();

  request.open('POST', param);

  for (const prop in extraHeaders) {
    request.setRequestHeader(prop, extraHeaders[prop]);
  }

  request.onreadystatechange = callback;
  request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

  if (data) {
    request.send(data);
  } else {
    request.send();
  }

  return request;
}

export function _postForm(url, callbackFunc, extraHeaders, data) {
  const request = new XMLHttpRequest();
  const formData = new FormData();

  request.open('POST', url);

  for (const prop in extraHeaders) {
    request.setRequestHeader(prop, extraHeaders[prop]);
  }

  for (const singleData in data) {
    formData.append(singleData, data[singleData]);
  }

  request.onreadystatechange = callbackFunc;

  request.send(formData);

  return request;
}

export function postForm(url, callbackFunc, extraHeaders, data) {
  return _postForm(url, callbackFunc, extraHeaders, data);
}

export function post(param, callback, extraHeaders, data) {
  return _post(param, callback, extraHeaders, data);
}
